export const checkForFandomCmpAllowed = (
  category: keyof typeof window.fandomCmp.allowed,
  container: Window = window,
): boolean => {
  return (
    container.fandomCmp !== undefined &&
    container.fandomCmp.ready &&
    container.fandomCmp.allowed[category]
  );
};
